import React from 'react'

const AddonItem = ({
  addon,
  isSelected,
  isDeactivated,
  isQuantityAdjustable,
  onCheck,
  onIncrement,
  onDecrement,
  onQuantityInputBlur,
  onQuantityInputChange,
  quantity = 1,
  showPrice = false,
  minQuantity = 1,
  maxQuantity = null,
  isCheckboxDisabled = false,
  displayMultiplier,
  childrenAddonItems,
  itemLevel = 0,
}) => {
  const newItemLevel = itemLevel + 1
  return (
    <div>
      <label
        style={{
          padding: '12px 16px',
          border: isDeactivated
            ? '1px solid #dde1ea'
            : isSelected
            ? '1px solid #26325f'
            : '1px solid #dde1ea',
          borderRadius: '8px',
          backgroundColor: isDeactivated
            ? '#f4f6fb'
            : isSelected
            ? '#eef1f9'
            : '#ffffff',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: isDeactivated ? 'not-allowed' : 'pointer',
          opacity: isDeactivated ? 0.6 : 1,
          minHeight: '56px',
        }}
      >
        <div style={{display: 'flex', gap: '12px', alignItems: 'center'}}>
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onCheck}
            disabled={isDeactivated || isCheckboxDisabled}
            style={{
              width: '16px',
              height: '16px',
              cursor:
                isDeactivated || isCheckboxDisabled ? 'not-allowed' : 'pointer',
              accentColor: '#26325f',
              flexShrink: 0,
            }}
          />
          <div>
            <p
              style={{
                fontWeight: 600,
                fontSize: '14px',
                color:
                  isDeactivated || isCheckboxDisabled ? '#6A7181' : '#1d2433',
                margin: 0,
              }}
            >
              {addon.name}
            </p>
            {showPrice && addon.formattedPrice && (
              <p
                style={{
                  fontSize: '13px',
                  color: '#6A7181',
                  margin: 0,
                  marginTop: '2px',
                }}
              >
                {addon.formattedPrice}
              </p>
            )}
          </div>
        </div>
        <div>
          {isSelected && isQuantityAdjustable && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: '16px',
              }}
            >
              {displayMultiplier && (
                <div
                  style={{
                    textAlign: 'center',
                    border: '1px solid #dde1ea',
                    paddingBlock: '4px',
                    paddingInline: '12px',
                    borderRadius: '6px',
                    marginInline: '8px',
                    backgroundColor: 'white',
                    fontSize: '13px',
                    color: '#1d2433',
                  }}
                >
                  {quantity * displayMultiplier} pgs
                </div>
              )}
              <button
                type="button"
                onClick={e => {
                  e.stopPropagation()
                  onDecrement()
                }}
                disabled={quantity <= minQuantity}
                style={{
                  width: '32px',
                  height: '32px',
                  background: 'white',
                  border: '1px solid #dde1ea',
                  borderRadius: '6px 0 0 6px',
                  cursor: quantity <= minQuantity ? 'not-allowed' : 'pointer',
                  color: '#26325f',
                  fontWeight: 600,
                  opacity: quantity <= minQuantity ? 0.4 : 1,
                }}
              >
                -
              </button>
              <input
                type="number"
                min={1}
                value={quantity}
                onBlur={e => onQuantityInputBlur(e.target.value)}
                onChange={e => onQuantityInputChange(e.target.value)}
                style={{
                  width: '44px',
                  height: '32px',
                  textAlign: 'center',
                  borderTop: '1px solid #dde1ea',
                  borderBottom: '1px solid #dde1ea',
                  borderLeft: 'none',
                  borderRight: 'none',
                  fontSize: '13px',
                  color: '#1d2433',
                  boxSizing: 'border-box',
                }}
                className="no-spinner"
              />
              <button
                type="button"
                onClick={e => {
                  e.stopPropagation()
                  onIncrement()
                }}
                disabled={maxQuantity && quantity >= maxQuantity}
                style={{
                  width: '32px',
                  height: '32px',
                  background: 'white',
                  border: '1px solid #dde1ea',
                  borderRadius: '0 6px 6px 0',
                  cursor:
                    maxQuantity && quantity >= maxQuantity
                      ? 'not-allowed'
                      : 'pointer',
                  color: '#26325f',
                  fontWeight: 600,
                  opacity: maxQuantity && quantity >= maxQuantity ? 0.4 : 1,
                }}
              >
                +
              </button>
            </div>
          )}
        </div>
      </label>
      <div
        style={{
          opacity: isSelected ? 1 : 0.4,
          pointerEvents: isSelected ? 'auto' : 'none',
          cursor: isSelected ? 'auto' : 'not-allowed',
        }}
      >
        {childrenAddonItems?.length > 0 &&
          childrenAddonItems.map((childItem, index) => {
            return (
              <div
                key={childItem.summaryInfo?.addOnCode || index}
                style={{marginLeft: `${newItemLevel * 28}px`, marginTop: '8px'}}
              >
                <AddonItem
                  addon={childItem}
                  isSelected={childItem.selectedItem}
                  isDeactivated={childItem.isIncompatible}
                  quantity={childItem.selectedItem?.quantity}
                  isQuantityAdjustable={childItem.quantityAdjustable}
                  minQuantity={childItem.minIncrementalQuantity}
                  maxQuantity={childItem.maxQuantity}
                  isCheckboxDisabled={childItem.isDefaultAdded}
                  childrenAddonItems={childItem.children}
                  displayMultiplier={childItem.displayMultiplier}
                  showPrice={true}
                  onCheck={childItem.orderControlFunctions.onCheck}
                  onIncrement={childItem.orderControlFunctions.onIncrement}
                  onDecrement={childItem.orderControlFunctions.onDecrement}
                  onQuantityInputBlur={
                    childItem.orderControlFunctions.onQuantityInputBlur
                  }
                  onQuantityInputChange={
                    childItem.orderControlFunctions.onQuantityInputChange
                  }
                  itemLevel={newItemLevel + 1}
                />
              </div>
            )
          })}
      </div>
    </div>
  )
}

AddonItem.defaultProps = {
  quantity: 1,
  showPrice: false,
  minQuantity: 1,
  maxQuantity: null,
}

export default AddonItem
